import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Label = theme(Headless.Label, [
  css({
    font: 'bodyEmphasized',
    [Headless.LabelVariants.invalid.true]: {
      color: 'critical',
    },
    [Headless.LabelVariants.position.top]: {
      // TODO: maybe use flexbox and a gap here instead
      display: css.value('block'),
      marginBottom: 'xsmall',
    },
  }),
]);
